import React from 'react'
import './styles.css'

interface SwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const Switch: React.FC<SwitchProps> = ({ label, checked, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return (
    <label className="switch-container">
      <input
        type="checkbox"
        className="switch-input"
        checked={checked}
        onChange={handleChange}
      />
      <span className="switch-slider">
        <span className="switch-dot"></span>
      </span>
      <span className="switch-label">{label}</span>
    </label>
  )
}
